import { act } from "react-dom/test-utils";
import { combineReducers } from "redux";

const AuthAction = (state = {}, action) => {
  switch (action.type) {
    case "login":
      return { user: action.payload };
    case "signup":
      return { user: action.payload };
    case "userupdate":
      return { user: action.payload };
    case "logout":
      return {};
    default:
      return state;
  }
};

const FilterMenuAction = (state = {}, action) => {
  switch (action.type) {
    case "setMenu":
      return { value: action.payload };
    case "ClearMenu":
      console.log("rdx clear");
        return {state:{}};
    default:
      return state;
  }
};

// const AddToCart = (state ={},action)=>{

//   switch(action.type){
//     case "addtocart":
//       return{value:action.payload};
//     default:
//       return state;
//   }

// }
function cartReducer(state = [], action) {
  switch (action.type) {
    case "addToCart":
      return [
        ...state,
        {
          product_id: action.payload.product_id,
          product_name: action.payload.product_name,
          product_image: action.payload.product_image,
          order_sizes: action.payload.order_sizes,
          karat: action.payload.karat,
          weight: action.payload.weight,
          order_price: action.payload.order_price,
          quantity: 1,
          variant_id: action.payload.variant_id,
          varient: action.payload.varient,
          packing_charges: action.payload.packing_charges
        },
      ];
    case "removeFromCart":
      return state.filter((val) => {
        if (
          val.product_id == action.payload.product_id &&
          val.order_sizes == action.payload.order_sizes &&
          val.karat == action.payload.karat
        ) {
          return false;
        } else {
          return true;
        }
      });
    case "increaseCount":
      return state.map((val) => {
        if (
          val.product_id == action.payload.product_id &&
          val.order_sizes == action.payload.order_sizes &&
          val.karat == action.payload.karat
        ) {
          return {
            ...val,
            quantity: val.quantity + 1,
          };
        } else {
          return val;
        }
      });
    case "decreaseCount":
      return state.map((val) => {
        if (
          val.product_id == action.payload.product_id &&
          val.order_sizes == action.payload.order_sizes &&
          val.karat == action.payload.karat
        ) {
          return {
            ...val,
            quantity: val.quantity - 1,
          };
        } else {
          return val;
        }
      });
    case "clearCart":
      return [];
    default:
      return state;
  }
}

const ParamsAction = (state = {}, action) => {
  switch (action.type) {
    case "setCollparams":
      return { CollId: action.payload };
    case "setBudparams":
        return { BudId: action.payload };
    case "setCatparams":
        return { CatId: action.payload };
    case "setSearchparams":
        return { searchVal: action.payload };
    case "setTypeparams":
        return { jweType: action.payload };
    case "ClearParams":
        return {};
    default:
      return state;
  }
};

const SortBy = (state = {}, action) => {
  switch (action.type) {
    case "setRatings":
      return { ratings: action.payload };
    // case "setPop":
    //   return { pop: action.payload };
    // case "setPriceLow":
    //   return { priceLow: action.payload };
    // case "setPriceHigh":
    //   return { priceHigh: action.payload };
    case "ClearSort":
      return {};
    default:
      return state;
  }
}

const HeaderCat = (state = {}, action) => {
  switch (action.type) {
    case "setCate":
      return { value: action.payload };
    default:
      return state;
  }
}
const Promocode = (state = {},action) =>{
  switch (action.type) {
    case "addPromo":
      return { promoValue: action.payload.promoValue,promoDetails :  action.payload.promoDetails,discount_type:action.payload.discount_type,code:action.payload.code};
    case "clearPromo":
        return {};
    default:
      return state;
  }
}

const LoginData = (state = {},action) =>{
  switch (action.type) {
    case "addData":
      return { id: action.payload.id,first_name :  action.payload.first_name,last_name:action.payload.last_name,email:action.payload.email,phone_number:action.payload.phone_number,avatar:action.payload.avatar,userType:action.payload.userType};
    case "removeData":
        return {};
    default:
      return state;
  }
}

const favList = (state = { qty:0}, action) => {
  switch (action.type) {
    case 'addfavCount':
      return { ...state, qty : action.payload};
    case 'clearFavCount': 
      return {};
    default:
      return state;
  }
}

const offerList = (state = {}, action) => {
  switch (action.type) {
    case 'addOfferCount':
      return { ...state, total_count : action.payload};
    default:
      return state;
  }
}

const exclusiveData = (state = {}, action) => {
  switch (action.type) {
    case 'exclusiveData':
      return{val : action.payload}
    default:
      return state;
  }
}
const Reducer = combineReducers({
  auth: AuthAction,
  menu: FilterMenuAction,
  params: ParamsAction,
  cart :cartReducer,
  HdCat: HeaderCat,
  promo :Promocode,
  login : LoginData,
  sort: SortBy,
  favCount: favList,
  exclue: exclusiveData,
  offerCount:offerList

});

export default Reducer;
